import { render, staticRenderFns } from "./VersionUpdateNotification.vue?vue&type=template&id=e721023e&scoped=true&"
import script from "./VersionUpdateNotification.vue?vue&type=script&lang=js&"
export * from "./VersionUpdateNotification.vue?vue&type=script&lang=js&"
import style0 from "./VersionUpdateNotification.vue?vue&type=style&index=0&id=e721023e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e721023e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VRow})
